import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Inclusivity flags */}
        <div className="footer-flags" aria-label="We welcome all individuals">
          <img
            src="/images/Nonbinary_flag.svg"
            alt="Non-binary pride flag"
            className="footer-flag"
          />
          <img
            src="/images/Trans.png"
            alt="Transgender pride flag"
            className="footer-flag"
          />
          <img
            src="/images/LGBTQ.png"
            alt="LGBTQ+ pride flag"
            className="footer-flag"
          />
        </div>

        <div className="footer-main">
          <div className="footer-col">
            <h4 className="footer-heading">Kidney ReACH &amp; ReACH Initiatives</h4>
            <p className="footer-text">
              Investigating how reproductive events, diseases, and hormones
              shape cardiovascular and kidney health for all individuals.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Explore</h4>
            <ul className="footer-links">
              <li><Link to="/lab-philosophy">Lab Philosophy</Link></li>
              <li><Link to="/people">People</Link></li>
              <li><Link to="/publications">Publications</Link></li>
              <li><Link to="/participate">Participate in Research</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-links">
              <li>
                <a href="mailto:kidney.reach@ucalgary.ca">kidney.reach@ucalgary.ca</a>
              </li>
              <li>
                <a href="mailto:reach@ucalgary.ca">reach@ucalgary.ca</a>
              </li>
              <li>
                <a href="tel:+14032109610">403-210-9610</a>
              </li>
              <li className="footer-address">
                Cal Wenzel Precision Health Building<br />
                Foothills Medical Campus<br />
                Calgary, Alberta
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {year} Kidney ReACH &amp; ReACH Initiatives &middot; University of Calgary</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;